import { useState, useEffect, useRef } from 'react'

import SearchFlyout from './components/SearchFlyout/SearchFlyout'
import SearchIcon from './components/SearchIcon/SearchIcon'
import SearchStatic from './components/SearchStatic/SearchStatic'

import './App.scss'

import staticData from './data/staticData'

// console.log('staticData', staticData)

const BOOST_URL =
    'https://services.mybcapps.com/bc-sf-filter/search/suggest?shop=monicaandandyonline.myshopify.com&page_limit=5&collection_limit=5&suggestion_limit=5&product_limit=8&product_available=true&variant_available=true&build_filter_tree=true&sort=relevance&fuzzy=1&q='

function App() {
    const [query, setQuery] = useState('')
    const [suggestions, setSuggestions] = useState([])
    const [pages, setPages] = useState([])
    const [collections, setCollections] = useState([])
    const [products, setProducts] = useState([])

    const inputElement = useRef(null)

    const onChangeHandler = (e) => {
        setQuery(e.target.value)
    }

    const handleSuggestionClick = (suggestion) => {
        setQuery(suggestion)
    }

    const handleClearSearch = () => {
        setQuery('')
    }

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            window.location.href = '/pages/search?q=' + query
        }
    }

    useEffect(() => {
        // query Boost suggestion API with each keystroke
        if (query && query.length > 0) {
            fetch(`${BOOST_URL}${query}`)
                .then((res) => res.json())
                .then((res) => {
                    // console.log(res)
                    setSuggestions(res.suggestions)
                    setPages(res.pages)
                    setCollections(res.collections)
                    setProducts(res.products)
                })
        }
    }, [query])

    useEffect(() => {
        if (inputElement.current) {
            inputElement.current.focus()
        }
    }, [])

    return (
        <div className="App Boost-InstantSearch-App">
            <div className="search-input-outer">
                <div className="search-input-inner">
                    <span className="search-icon">
                        <SearchIcon />
                    </span>
                    <input
                        id="boost-search-input"
                        type="search"
                        placeholder="Search here..."
                        value={query}
                        onChange={onChangeHandler}
                        autoFocus
                        ref={inputElement}
                        onKeyUp={(e) => handleKeyPress(e)}
                        inputMode="search"
                    />
                    <div className="clear-search" onClick={handleClearSearch}>
                        <span className="clear-text">Clear</span>
                    </div>
                    <div className="cancel-search">
                        <span className="cancel-icon">&times;</span>
                    </div>
                </div>
            </div>
            {query && query.length > 0 && (
                <div className="search-results-outer">
                    <div className="search-results-inner">
                        <SearchFlyout
                            suggestions={suggestions}
                            handleSuggestionClick={handleSuggestionClick}
                            collections={collections}
                            pages={pages}
                            products={products}
                            query={query}
                        />
                    </div>
                </div>
            )}
            {!query && (
                <SearchStatic
                    staticData={staticData}
                    handleSuggestionClick={handleSuggestionClick}
                />
            )}
        </div>
    )
}

export default App
